import React from 'react';
import './DashboardSkeleton.css';

export const DashboardSkeleton: React.FC = () => {
    return (
        <div className="dashboard-skeleton">
            {/* Project Selector Skeleton */}
            <div className="skeleton-selector">
                <div className="skeleton-selector-label">
                    <div className="skeleton-icon skeleton-pulse"></div>
                    <div className="skeleton-text skeleton-text--short skeleton-pulse"></div>
                </div>
                <div className="skeleton-select skeleton-pulse"></div>
            </div>

            {/* Two Column Layout */}
            <div className="skeleton-columns">
                {/* Left Column */}
                <div className="skeleton-column">
                    {/* Metrics Section */}
                    <div className="skeleton-section">
                        <div className="skeleton-section-header">
                            <div className="skeleton-icon skeleton-pulse"></div>
                            <div className="skeleton-text skeleton-text--medium skeleton-pulse"></div>
                        </div>
                        <div className="skeleton-metrics-grid">
                            {[...Array(6)].map((_, i) => (
                                <div className="skeleton-metric-card skeleton-pulse" key={i}>
                                    <div className="skeleton-metric-content">
                                        <div className="skeleton-text skeleton-text--short skeleton-pulse"></div>
                                        <div className="skeleton-text skeleton-text--medium skeleton-pulse"></div>
                                    </div>
                                    <div className="skeleton-metric-icon skeleton-pulse"></div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Planning Section */}
                    <div className="skeleton-section">
                        <div className="skeleton-section-header">
                            <div className="skeleton-icon skeleton-pulse"></div>
                            <div className="skeleton-text skeleton-text--medium skeleton-pulse"></div>
                        </div>
                        <div className="skeleton-planning-grid">
                            {[...Array(4)].map((_, i) => (
                                <div className="skeleton-planning-card skeleton-pulse" key={i}>
                                    <div className="skeleton-planning-icon skeleton-pulse"></div>
                                    <div className="skeleton-planning-content">
                                        <div className="skeleton-text skeleton-text--short skeleton-pulse"></div>
                                        <div className="skeleton-text skeleton-text--long skeleton-pulse"></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Right Column */}
                <div className="skeleton-column">
                    {/* Monthly Data Section */}
                    <div className="skeleton-section">
                        <div className="skeleton-section-header">
                            <div className="skeleton-icon skeleton-pulse"></div>
                            <div className="skeleton-text skeleton-text--medium skeleton-pulse"></div>
                        </div>
                        <div className="skeleton-monthly-grid">
                            {[...Array(4)].map((_, i) => (
                                <div className="skeleton-monthly-card skeleton-pulse" key={i}>
                                    <div className="skeleton-monthly-icon skeleton-pulse"></div>
                                    <div className="skeleton-monthly-content">
                                        <div className="skeleton-text skeleton-text--short skeleton-pulse"></div>
                                        <div className="skeleton-text skeleton-text--medium skeleton-pulse"></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Users Section */}
                    <div className="skeleton-section">
                        <div className="skeleton-section-header">
                            <div className="skeleton-icon skeleton-pulse"></div>
                            <div className="skeleton-text skeleton-text--medium skeleton-pulse"></div>
                        </div>
                        <div className="skeleton-users-list">
                            {[...Array(5)].map((_, i) => (
                                <div className="skeleton-user-row" key={i}>
                                    <div className="skeleton-avatar skeleton-pulse"></div>
                                    <div className="skeleton-user-info">
                                        <div className="skeleton-text skeleton-text--medium skeleton-pulse"></div>
                                        <div className="skeleton-text skeleton-text--short skeleton-pulse"></div>
                                    </div>
                                    <div className="skeleton-user-actions">
                                        <div className="skeleton-chip skeleton-pulse"></div>
                                        <div className="skeleton-button skeleton-pulse"></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Loading indicator */}
            <div className="skeleton-loading-indicator">
                <div className="skeleton-spinner"></div>
                <span>Chargement du tableau de bord...</span>
            </div>
        </div>
    );
};

export default DashboardSkeleton;
